import { render, staticRenderFns } from "./Wizard-Time.vue?vue&type=template&id=23f1e8a2&scoped=true"
import script from "./Wizard-Time.vue?vue&type=script&lang=js"
export * from "./Wizard-Time.vue?vue&type=script&lang=js"
import style0 from "./Wizard-Time.vue?vue&type=style&index=0&id=23f1e8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f1e8a2",
  null
  
)

export default component.exports